import { render } from "./dpc-p-calendar-event-list.vue?vue&type=template&id=3ebe414b"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__